import React from 'react';
import { AlertTriangle, TrendingUp } from 'lucide-react';
import { problemStatement } from '../../data/mock';

const ProblemSection = () => {
  return (
    <section className="py-20 bg-gray-900 text-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          {/* Problem */}
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 bg-amber-500/20 text-amber-400 px-4 py-2 rounded-full text-sm font-medium mb-6">
              <AlertTriangle className="w-4 h-4" />
              The Problem
            </div>
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              {problemStatement.title}
            </h2>
            <p className="text-gray-300 text-lg leading-relaxed">
              {problemStatement.content}
            </p>
          </div>

          {/* Divider */}
          <div className="flex items-center justify-center gap-4 my-12">
            <div className="h-px bg-gray-700 flex-1"></div>
            <TrendingUp className="w-8 h-8 text-teal-400" />
            <div className="h-px bg-gray-700 flex-1"></div>
          </div>

          {/* Solution */}
          <div className="text-center">
            <div className="inline-flex items-center gap-2 bg-teal-500/20 text-teal-400 px-4 py-2 rounded-full text-sm font-medium mb-6">
              The Solution
            </div>
            <p className="text-white text-xl leading-relaxed font-medium">
              {problemStatement.solution}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
